import angular from "angular";

angular
    .module('app')
    .component('mobizonMessagesControl', {
        template: require('./mobizon-messages-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', '$timeout', '$httpParamSerializer', controller],
        bindings: {
            datetime: '@',
            balanceData: '<',
        }
    });

function controller($uibModal, Notifier, $http, $httpParamSerializer) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = 20;
    $ctrl.phone = null;
    $ctrl.status = null;
    $ctrl.startDate = null;
    $ctrl.endDate = null;

    $ctrl.querySerializer = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        // let queryParams = {
        //     start_date: $ctrl.startDate ? moment($ctrl.startDate).format('YYYY-MM-DD') : null,
        //     end_date: $ctrl.endDate ? moment($ctrl.endDate).format('YYYY-MM-DD') : null,
        // };

        // $ctrl.querySerializer = $httpParamSerializer(queryParams);

        $http
            .get('/admin/mobizon-messages/get-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    phone: $ctrl.phone ? $ctrl.phone : null,
                    user_id: $ctrl.user ? $ctrl.user.id : null,
                    status: $ctrl.status ? $ctrl.status : null,
                    start_date: $ctrl.startDate ? $ctrl.startDate : null,
                    end_date: $ctrl.endDate ? $ctrl.endDate : null,
                }
            })
            .then(
                function (response) {
                    $ctrl.messages = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {
                    console.log(error);
                }
            );
    };

    // $ctrl.getBalance = function () {
    //     $http
    //         .get('/admin/mobizon-messages/get-balance')
    //         .then(
    //             function (response) {
    //                 $ctrl.balanceData = response.data.data;
    //                 $ctrl.datetime = response.data.datetime;
    //                 Notifier.success('Текущий баланс получен успешно', /* Delay(sec) : */ 4);
    //             },
    //             function (error) {
    //                 alert(error.data.message || 'Undefined error');
    //             }
    //         );
    // };

    $ctrl.getUsers = function (fragment) {
        return $http
            .get('/admin/users/get-by-fragment', {params: {fragment}})
            .then(
                function (response) {
                    return response.data.users;
                }
            )
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.perPage = 20;
        $ctrl.getList();
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.perPage = 20;
        $ctrl.phone = null;
        $ctrl.status = null;
        $ctrl.startDate = null;
        $ctrl.endDate = null;
        $ctrl.getList();
    };

    $ctrl.moreDetails = function (message) {

        $uibModal
            .open({
                component: 'messageMoreDetails',
                resolve: {
                    message: function () {
                        return message;
                    }
                },
                backdrop: 'static',
                size: 'lg'
            })
    };


}
